import { useMutation } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';
import { approveAgentAction, rejectAgentAction } from './action.api';

/**
 * Approving a write invalidates every query: the agent can touch any module, and this client has
 * no way to know which screen just went stale. A blunt invalidation is the honest option — a
 * hand-maintained map of tool to query key would drift from the catalog immediately.
 */
export const useApproveAgentAction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: approveAgentAction,
    onSuccess: () => {
      queryClient.invalidateQueries();
    }
  });
};

export const useRejectAgentAction = () => useMutation({ mutationFn: rejectAgentAction });
